export const DASHBOARD_MODULE = 'Dashboard';
export const MYACCOUNT_MODULE = 'My Account';
export const VALID_VALUE_MODULE = 'Valid Value';
export const SYSTEM_PARAMETER_MODULE = 'System Parameter';
export const SYSTEM_LIST_MODULE = 'System List';
export const MAP_DEFINITION_MODULE = 'Map Definition';
export const TEXT_MANAGEMENT_MODULE = 'Text Management';

export const BANK_ACCOUNT_MODULE = 'Bank Account';
export const FUND_CODE_MODULE = 'Fund Code';
export const BUDGET_MAINTENANC_MODULE = 'Budget Maintenance';
export const FISCAL_PEND_CRITERIA_MODULE = 'Fiscal Pend Criteria';
export const FINANCIAL_ENTITY_MODULE = 'Financial Entity';
export const ACCOUNT_RECEIVABLE_MODULE = 'Accounts Receivable';
export const BULK_MAINTENANCE_MODULE = 'Bulk Maintenance';
export const PAYOUT_MODULE = 'Payout';
export const PAYOUT_APPROVAL_MODULE = 'Payout Approval';
export const PAYMENT_CRITERIA_MODULE = 'Payment Criteria';
export const FINANCIAL_RECEIPT_MODULE = 'Financial Receipt';
export const FINANCIAL_DATA_UPLOAD_MODULE = 'Data Upload';
export const FINANCIAL_INQUIRY_MODULE = 'Financial Inquiry';
export const PAYMENT_STATUS_INQUIRY_MODULE = 'Payment Status Inquiry';
export const MAINTAIN_1099_MODULE = 'Maintain 1099';
export const APPROVAL_1099_MODULE = '1099 Approval';
export const EVENT_LOGGING_MODULE = 'Event Logging';
export const GLOBAL_AUDIT_MODULE = 'Global Audit Search';
export const SITE_MAP_MODULE = 'Site Map';
